import { EmployeesPageHeader } from './components/EmployeesPageHeader';
import { EmployeesList } from './EmployeesList.main';

export { EmployeesList, EmployeesPageHeader };
